import React, { useState } from 'react';
import { ReactSVG } from 'react-svg'
import { useLocation, useNavigate } from 'react-router-dom'
import { useIntl } from 'react-intl';
import settingsIcon from '../../../../../../assets/images/layout/settings-icon.svg'
import NotificationIcon from '../NotificationIcon'
import QuestionMark from '../QuestionMark'
import SupportBoxPopup from '../QuestionMark/SupportBoxPopup';
import { useDispatch, useSelector } from 'react-redux';
import DropdownMenu from '../DropDownMenu/DropdownMenu';
import defaultCompanyLogo from "../../../../../../assets/images/search/squared-company-logo-one.svg";
import { setDetailsDialogUnsavedChanges } from '../../../../../../reducers/positions';
import SaveSettingsChangesAlert from '../../../../../pages/Settings/save-changes-alert';
import { ApplicationRoutes } from '../../../../../constants';
import { Info } from 'lucide-react';
import HowItWorks from '../HowItWorks';
import { useInterviewNavigationGuard } from '../../../../../company/interview-builder/interview-navigation-guard';
import LanguageSelector from '../LanguageSelector';

const UserInformation = ({ showNotificationBanner, setMenuDisabled, isNotificationActive }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const intl = useIntl();
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [isFaqOpen, setFaqOpen] = useState(false);
  const { companyConfiguration } = useSelector((state) => state.userInformationReducer)
  const [failedLogoUrl, setFailedLogoUrl] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [isMessageAlertOpen, setIsMessageAlertOpen] = useState(false);
  const { hasDetailsDialogUnsavedChanges } = useSelector((state) => state.vacanciesReducer);
  const [nextUrl, setNextUrl] = useState(null);
  const { requestInterviewNavigation } = useInterviewNavigationGuard();

  const handleNavigation = () => {
    if (location.pathname === ApplicationRoutes.hi5Settings) return;
    requestInterviewNavigation(() => {
      if (hasDetailsDialogUnsavedChanges) {
        setNextUrl(ApplicationRoutes.hi5Settings);
        setIsMessageAlertOpen(true);
      } else {
        navigate(ApplicationRoutes.hi5Settings, { state: { returnTo: location } });
      }
    });
  };

  const handleConfirm = () => {
    if (hasDetailsDialogUnsavedChanges) {
      setIsMessageAlertOpen(false)
      dispatch(setDetailsDialogUnsavedChanges(false));
      if (nextUrl) {
        navigate(nextUrl, { state: { returnTo: location } });
      }
    }
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const togglePopup = () => {
    setPopupOpen(!isPopupOpen);
    setMenuDisabled(!isPopupOpen)
  };

  const handleSupportClick = () => {
    setFaqOpen(false);
    setPopupOpen(true);
    setMenuDisabled(true);
  };

  return (
    <>
      <div className="flex items-center h-full gap-4 xl:gap-6 pr-5">
        <LanguageSelector />
        <Info onClick={() => setFaqOpen(true)} size={26} strokeWidth={2} className="cursor-pointer text-standart-ocean hover:text-light-purple active:text-black" aria-label={intl.formatMessage({ id: "teamroom.header.howItWorks.aria" })} />
        <QuestionMark onClick={togglePopup} />
        <NotificationIcon isActive={isNotificationActive} showNotificationBanner={showNotificationBanner} />
        <ReactSVG onClick={() => handleNavigation()} src={settingsIcon} className="cursor-pointer text-standart-ocean hover:text-light-purple active:text-black" />
        <button type="button" onClick={handleClick} aria-label={intl.formatMessage({ id: "teamroom.settings.tab.account" })}>
          <img
            className="h-12 w-12 border rounded-full object-contain p-1 cursor-pointer select-none"
            src={companyConfiguration.logo_url && companyConfiguration.logo_url !== failedLogoUrl ? companyConfiguration.logo_url : defaultCompanyLogo}
            onError={() => setFailedLogoUrl(companyConfiguration.logo_url)}
            alt={intl.formatMessage({ id: "teamroom.settings.companyLogo" })}
          />
        </button>
        <DropdownMenu anchorEl={anchorEl} handleClose={handleClose} />
        {isPopupOpen && <SupportBoxPopup onClose={togglePopup} />}
        {isFaqOpen && <HowItWorks onClose={() => setFaqOpen(false)} onSupportClick={handleSupportClick} />}
      </div>
      <SaveSettingsChangesAlert
        isMessageAlertOpen={isMessageAlertOpen}
        setIsMessageAlertOpen={setIsMessageAlertOpen}
        handleConfirm={handleConfirm}
      />
    </>
  )
}

export default UserInformation
